import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import Vuetify from 'vuetify'
// import Vuetify from 'vuetify/lib/framework'
import vuetify from './plugins/vuetify'



import 'vuetify/lib/styles/main.css' 
import { loadFonts } from './plugins/webfontloader'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app')
